/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreatePoolRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {CreatePoolResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const createPool = (request:CreatePoolRequest, options?: CashRequestOptions) => post<CreatePoolRequest, CreatePoolResponse>("/2.0/cash/create-pool", request, {...options, rejectOnError: true })